module.exports = __webpack_public_path__ + "img/six-questionnaire.85a5c561.png";